export default __webpack_public_path__ + "static/media/loading.0b63ab02.svg";